import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import BulkUpload from "./BulkUpload/BulkUpload";
import { createHouseDetail, fetchSchemesData } from "../../../services/api";
import AlertMsg from "../../../components/AlertMsg/AlertMsg";
import Loading from "../../../components/Loading/Loading";

const AddHouseDetails = () => {
  const getCurrentDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };
  const initialState = {
    regNo: "",
    yearId: 0,
    schemeId: 0,
    blockId: 0,
    villageId: 0,
    panchayatId: 0,
    fatherorHusband: "",
    beneficiary: "",
    sanctionNo: "",
    categoryId: 0,
    releasedAmount: null,
    installment: null,
    creditDate: getCurrentDate(),
    houseStatusId: null,
    activeStatus: true,
  };
  const [schemesOptions, setSchemesOptions] = useState([]);
  const [errors, setErrors] = useState({});
  const [alert, setAlert] = useState({ visible: false, message: "", type: "" });
  const [loading, setLoading] = useState(false);
  const validateForm = () => {
    const newErrors = {};

    // Reg No validation
    if (!formData.regNo.trim()) {
      newErrors.regNo = "Registration number is required";
    }

    // Year validation
    if (!formData.yearId) {
      newErrors.yearId = "Please select a year";
    }
    // Year validation
    if (!formData.schemeId) {
      newErrors.schemeId = "Please select a Scheme";
    }

    // Block validation
    if (!formData.blockId) {
      newErrors.blockId = "Please select a block";
    }

    // Village validation
    if (!formData.villageId) {
      newErrors.villageId = "Please select a village";
    }

    // Panchayat validation
    if (!formData.panchayatId) {
      newErrors.panchayatId = "Please select a panchayat";
    }

    // Father/Husband validation
    if (!formData.fatherorHusband.trim()) {
      newErrors.fatherorHusband = "Father or Husband name is required";
    }

    // Beneficiary validation
    if (!formData.beneficiary.trim()) {
      newErrors.beneficiary = "Beneficiary name is required";
    }

    // Category validation
    if (!formData.categoryId) {
      newErrors.categoryId = "Please select a category";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // Return true if no errors
  };
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);
  const { years, categories, blocks, panchayats, villages } = useSelector(
    (state) => state.housingData
  );
  const [formData, setFormData] = useState(initialState);

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "releasedAmount" || name === "installment") {
      if (value === "" || /^[0-9]*$/.test(value)) {
        setFormData({
          ...formData,
          [name]: value === "" ? null : Number(value),
        });
      }
    } else if (name === "activeStatus") {
      setFormData({
        ...formData,
        [name]: value === "true",
      });
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };

  const handleMoveDetails = () => {
    setTimeout(() => {
      history.push("/housedetails");
    }, 2000);
  };

  const handleCancel = () => {
    setFormData(initialState);
    history.push("/housedetails");
  };
  const fetchSchemes = async () => {
    try {
      const response = await fetchSchemesData();
      setSchemesOptions(response.data);
    } catch (error) {
      console.error("Error fetching scheme data:", error);
    }
  };
  useEffect(() => {
    fetchSchemes();
  }, []);

  const handleSubmit = async () => {
    if (!validateForm()) {
      return;
    }
    setLoading(true);
    try {
      setIsLoading(true);
      const response = await createHouseDetail(formData);

      console.log("API Response:", response);

      if (response.status !== 200 && response.status !== 201) {
        throw new Error(
          `Failed to submit the form. Status: ${response.status}`
        );
      }

      console.log("Form submitted successfully:", response.data);
      setAlert({
        visible: true,
        message: "House Detail added successfully!",
        type: "success",
      });

      setFormData(initialState);
      handleMoveDetails();
    } catch (error) {
      setAlert({
        visible: true,
        message: "Error adding House Detail. Please try again.",
        type: "error",
      });
      console.error("Error submitting form:", error);
    }finally {
      setLoading(false);
    }
  };

  const getSortedOptions = (options) => {
    return options
      .filter((option) => option && option.name.trim() !== "") // Filter out empty values
      .sort((a, b) => a.name.localeCompare(b.name)) // Sort in ascending order
      .map((option) => (
        <option key={option.id} value={option.id}>
          {option.name}
        </option>
      ));
  };
  return (
    <section>
      {loading && <Loading/>}
      {!loading && (
      <div className="details-container">
        {alert.visible && (
          <AlertMsg
            message={alert.message}
            type={alert.type}
            onClose={() => setAlert({ ...alert, visible: false })}
          />
        )}
        <div className="container-head p-15">
          <h2>House Details</h2>
        </div>
        <form onSubmit={(e) => e.preventDefault()}>
          <div className="details-row">
            <div className={`inputs-details ${errors.regNo ? "error" : ""}`}>
              <label>Reg No</label>
              <input
                type="text"
                name="regNo"
                value={formData.regNo}
                onChange={handleChange}
                placeholder="Reg No"
                className={errors.regNo ? "input-error" : ""}
              />
            </div>
            <div className="inputs-details">
              <label>Year</label>
              <select
                name="yearId"
                value={formData.yearId}
                onChange={handleChange}
                className={errors.yearId ? "input-error" : ""}
              >
                <option value="">Select Year</option>
                {getSortedOptions(years)}
              </select>
            </div>
          </div>

          <div className="details-row">
            <div className="inputs-details">
              <label>Block</label>
              <select
                name="blockId"
                value={formData.blockId}
                onChange={handleChange}
                className={errors.blockId ? "input-error" : ""}
              >
                <option value="">Select Block</option>
                {getSortedOptions(blocks)}
              </select>
            </div>
            <div className="inputs-details">
              <label>Village Name</label>
              <select
                name="villageId"
                value={formData.villageId}
                onChange={handleChange}
                className={errors.villageId ? "input-error" : ""}
              >
                <option value="">Select Village</option>
                {getSortedOptions(villages)}
              </select>
            </div>
          </div>

          <div className="details-row">
            <div className="inputs-details">
              <label>Panchayat</label>
              <select
                name="panchayatId"
                value={formData.panchayatId}
                onChange={handleChange}
                className={errors.panchayatId ? "input-error" : ""}
              >
                <option value="">Select Panchayat</option>
                {getSortedOptions(panchayats)}
              </select>
            </div>
            <div className="inputs-details">
              <label>Father/Husband Name</label>
              <input
                type="text"
                name="fatherorHusband"
                value={formData.fatherorHusband}
                onChange={handleChange}
                placeholder="Father/Husband Name"
                className={errors.fatherorHusband ? "input-error" : ""}
              />
            </div>
          </div>

          <div className="details-row">
            <div className="inputs-details">
              <label>Beneficiary Name</label>
              <input
                type="text"
                name="beneficiary"
                value={formData.beneficiary}
                onChange={handleChange}
                placeholder="Beneficiary"
                className={errors.beneficiary ? "input-error" : ""}
              />
            </div>
            <div className="inputs-details">
              <label>Category</label>
              <select
                name="categoryId"
                value={formData.categoryId}
                onChange={handleChange}
                // disabled
                className={errors.categoryId ? "input-error" : ""}
              >
                <option value="">Select Category</option>
                {getSortedOptions(categories)}
              </select>
            </div>
            {/* <div className="inputs-details">
            <label>Sanction No</label>
            <input
              type="text"
              name="sanctionNo"
              value={formData.sanctionNo}
              onChange={handleChange}
              placeholder="Sanction No"
              className={errors.sanctionNo ? "input-error" : ""}
            />
          </div> */}
          </div>

        
          <div className="details-row">
          <div className="inputs-details">
              <label>Scheme</label>
              <select
                name="schemeId" // Make sure the name corresponds to 'schemeId' in your formData
                value={formData.schemeId}
                onChange={handleChange}
                className={errors.schemeId ? "input-error" : ""}
              >
                <option value="">Select Scheme</option>
                {schemesOptions.map((scheme) => (
                  <option key={scheme.id} value={scheme.id}>
                    {scheme.name}
                  </option>
                ))}
              </select>
            </div>
            <div className="inputs-details">
              <div className="details-button j-end">
                <button
                  type="button"
                  className="close-btn"
                  onClick={handleCancel}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="save-btn"
                  onClick={handleSubmit}
                  disabled={isLoading}
                >
                  {isLoading ? "Loading..." : "Save"}
                </button>
              </div>
            </div>
          </div> 
        </form>
      </div>
      )}

      <div className="file-upload-container">
        <BulkUpload />
      </div>
    </section>
  );
};

export default AddHouseDetails;
